import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../navbar/Navbar';
import Footer from '../footer/Footer';
import WhatsAppButton from '../whatsapp/WhatsAppButton';
import FloatingBubbles from './FloatingBubbles';

const Layout = () => {
  return (
    <>
      <Navbar />
      {/* <FloatingBubbles /> */}
      <main id="main-content" role="main">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppButton />
    </>
  );
};

export default Layout;